<template>
	<div>
    
      <b-tabs content-class="mt-3" v-model="tabIndex" v-on:activate-tab="checksave">
        <b-tab title="Company Info">
          
              <b-form-group
                label="Company Name"
                label-for="company_name"
              >
                <b-form-input id="company_name" v-model="settings.name" :required="true" @change="updateSetting" trim></b-form-input>
              </b-form-group>

              <b-form-group
                label="Company Email"
                description="This will appear on your company profile."
                label-for="email"
              >
                <b-form-input id="email" v-model="settings.email" :required="false" @change="updateSetting" trim></b-form-input>
              </b-form-group>

              <b-form-group
                label="Company Telephone"
                description="This will appear on your company profile."
                label-for="telephone"
              >
                <b-form-input id="telephone" v-model="settings.telephone" :required="false" @change="updateSetting" trim></b-form-input>
              </b-form-group>

              <b-form-group
                label="Website URL"
                label-for="website"
              ><b-input-group>
                <b-form-input id="website" v-model="websiteDomain" :required="false" @change="updateSetting()" trim></b-form-input>
                    <template #prepend>

                      <b-form-select class="rounded-left" v-model="websiteProtocol" :options="[{ value: 'http://', text: 'http://'},{ value: 'https://', text: 'https://'}]" @change="updateSetting()"></b-form-select>
                     
                    </template>
                  </b-input-group>
              </b-form-group>

              <b-form-group
                label="Profile Text"
                description="Write a sentence or two that explains exactly what you do. This will appear on your company profile."
                label-for="profile"
              >
                <b-form-textarea id="profile" v-model="settings.profile" :required="false" @change="updateSetting()" trim></b-form-textarea>
              </b-form-group>
              <b-form-group
                label="Twitter URL"
                label-for="twitter"
              >
                <b-input-group :prepend="twitterPrefix">
                  <b-form-input id="twitter" v-model="twitterURL" :required="false" @change="updateSetting()" trim></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group
                label="Linkedin URL"
                label-for="linkedin"
              >
              <b-input-group :prepend="linkedinPrefix">
                <b-form-input id="linkedin" v-model="linkedinURL" :required="false" @change="updateSetting()" trim></b-form-input>
              </b-input-group>
              </b-form-group>

              <b-form-group
                label="Facebook URL"
                label-for="facebook"
              >
              <b-input-group :prepend="facebookPrefix">
                <b-form-input id="facebook" v-model="facebookURL" :required="false" @change="updateSetting()" trim></b-form-input>
              </b-input-group>
              </b-form-group>

              <b-form-group
                label="Instagram URL"
                label-for="instagram"
              >
                <b-input-group :prepend="instagramPrefix">
                  <b-form-input id="instagram" v-model="instagramURL" :required="false" @change="updateSetting()" trim></b-form-input>
                </b-input-group>
              </b-form-group>

              <b-form-group
                label="Booking URL"
                description="eg. Calendly"
                label-for="booking_url"
              ><b-input-group>
                <b-form-input id="booking_url" v-model="bookingDomain" :required="false" @change="updateSetting()" trim></b-form-input>
                    <template #prepend>

                      <b-form-select class="rounded-left" v-model="bookingProtocol" :options="[{ value: 'http://', text: 'http://'},{ value: 'https://', text: 'https://'}]" @change="updateSetting()"></b-form-select>
                     
                    </template>
                  </b-input-group>
              </b-form-group>



        </b-tab>

        <b-tab title="Logo & Backgrounds">
          
          <b-form-group
                label="Company Logo"
                label-for="company_logo"
              >
              <div class="row justify-content-center">
                <div class="col-3"><company-logo :key="settings_loaded" input-id="company_logo" name="company_logo" :image="settings.logo" @change="updateSetting('logo',$event)"></company-logo></div>
              </div>
          </b-form-group>

          <b-form-group
                label="Default Deck Background"
                label-for="background"
              >
              <div class="row justify-content-center">
                <div class="col"><deck-background :key="settings_loaded" input-id="background" name="background" :image="settings.background" @change="updateSetting('background',$event)"></deck-background></div>
              </div>
          </b-form-group>

          <b-form-group
                label="Company Profile Image"
                label-for="profile-background"
              >
              <div class="row justify-content-center">
                <div class="col-6"><profile-background :key="settings_loaded" input-id="profile-background" name="profile-background" :image="settings.profile_background" @change="updateSetting('profile_background',$event)"></profile-background></div>
              </div>
          </b-form-group>



        </b-tab>
        <b-tab title="Colours & Fonts">
          <form ref="previewform" action="/company/preview" method="POST" target="accountPreview">


          <div class="row">
            <b-form-group
                  label="Brand Accent Colour:"
                  label-for="accent_color"
                  description="This will be applied to card headlines, buttons and some card backgrounds."
                  class="col-md-6"
                >
              <company-color-picker :key="settings_loaded" name="accent_color" :value="settings.accent_color" @change="updateSetting('accent_color',$event)"></company-color-picker>
            </b-form-group>
            <b-form-group
                  label="Additional Colours:"
                  label-for="secondary_color"
                  description="You can define additional brand colours here for quick selection."
                  class="col-md-6"
                >
              <company-color-picker :key="settings_loaded" name="secondary_color" :value="settings.secondary_color" @change="updateSetting('secondary_color',$event)"></company-color-picker>
              <company-color-picker :key="settings_loaded" name="tertiary_color" :value="settings.tertiary_color" @change="updateSetting('tertiary_color',$event)"></company-color-picker>
            </b-form-group>
          </div> 

          <hr />
          <div class="row">
            <b-form-group
                  label="Heading Font"
                  label-for="heading_font"
                  class="col-md-5"
                >
                  <b-form-select id="heading_font" name="heading_font" v-model="settings.heading_font" :options="font_select" @change="updateSetting('heading_font',settings.heading_font)"></b-form-select>
            </b-form-group>
            <b-form-group
                  label="Heading Size"
                  label-for="heading_size"
                  class="col-md-2"
                >
                  <b-form-spinbutton id="heading_size" v-model="settings.heading_size" name="heading_size" min="1" max="4" @change="updateSetting('heading_size',settings.heading_size)"></b-form-spinbutton>
            </b-form-group>
            <b-form-group
                  label="Heading Colour:"
                  label-for="contrast_color"
                  description="This is default colour of your headings."
                  class="col-md-5"
                >
              <company-color-picker :key="settings_loaded" name="heading_color" :value="settings.heading_color" @change="updateSetting('heading_color',$event)"></company-color-picker>
            </b-form-group>

          </div>
          <div class="row">
            <b-form-group
                  label="Text Font"
                  label-for="body_font"
                  class="col-md-5"
                >
                  <b-form-select id="body_font" name="body_font" v-model="settings.body_font" :options="font_select" @change="updateSetting('body_font',settings.body_font)"></b-form-select>
            </b-form-group>
            <b-form-group
                  label="Text Size"
                  label-for="body_size"
                  class="col-md-2"
                >
                  <b-form-spinbutton id="body_size" v-model="settings.body_size" name="body_size" min="1" max="4" @change="updateSetting('body_size',settings.body_size)"></b-form-spinbutton>
            </b-form-group>
            <b-form-group
                  label="Text Colour:"
                  label-for="contrast_color"
                  description="This is default colour of the body copy text."
                  class="col-md-5"
                >
              <company-color-picker :key="settings_loaded" name="contrast_color" :value="settings.contrast_color" @change="updateSetting('contrast_color',$event)"></company-color-picker>
            </b-form-group>

          </div>
                    <hr />

          <div class="row">
            <b-form-group
                  label="Card Background Colour:"
                  label-for="ground_color"
                  description="This is default background colour for cards in your SizzleDeck."
                  class="col-md-4"
                >
              <company-color-picker :key="settings_loaded" name="ground_color" :value="settings.ground_color" @change="updateSetting('ground_color',$event)"></company-color-picker>
            </b-form-group>
            <b-form-group
                  label="Button Colour:"
                  label-for="button_background_color"
                  description="This is default colour of the body copy text."
                  class="col-md-4"
                >
              <company-color-picker :key="settings_loaded" name="button_background_color" :value="settings.button_background_color" @change="updateSetting('button_background_color',$event)"></company-color-picker>
            </b-form-group>
            <b-form-group
                  label="Button Text Colour:"
                  label-for="button_text_color"
                  description="This is default colour of the body copy text."
                  class="col-md-4"
                >
              <company-color-picker :key="settings_loaded" name="button_text_color" :value="settings.button_text_color" @change="updateSetting('button_text_color',$event)"></company-color-picker>
            </b-form-group>
          </div>
          <input type="hidden" name="_token" :value="csrf">
          </form>
                    <hr />

          <div class="row">
            <b-form-group label="Preview" class="col-12">
              <div id="buildArea" class="border p-3 w-100">
                <iframe class="border-0" src="/company/preview" width="100%" height="450" ref="accountPreviewIframe" id="accountPreview" name="accountPreview"></iframe>

              </div>
            </b-form-group>
          </div>


        </b-tab>
      
        <b-tab title="Default Profile Settings">

              <b-form-group
                label="Display Profile - Can be overridden on a per deck basis."
                label-for="default_show_profile"
                class="pt-3"
              >
                <b-form-checkbox id="default_show_profile" v-model="settings.show_combined_profile" name="check-button" @change="updateSetting()" switch>
                  {{ settings.show_combined_profile ? 'Show': 'Hide'}} Profile Button by Default
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                label="Which image should be shown on the profile - Can be overridden on a per deck basis."
                label-for="default_profile_image"
                class="pt-3"
              >
                            <b-form-radio-group
              v-model="settings.combined_profile_bubble_image"
              :options="[{ text: 'None', value: null },
                         { text: 'Logo', value: 'logo' },
                         { text: 'Profile Pic', value: 'profile_pic' }]"
              button-variant="outline-primary"
              
              name="radio-btn-outline"
              buttons
              class="mb-3"
            ></b-form-radio-group>



        <b-form-group label="Profile Bubble Text">
             <b-form-input
              v-model="settings.combined_profile_bubble_text"
            ></b-form-input>
        </b-form-group>
        <b-form-group label="Profile Bubble Button">
             <b-form-input
              v-model="settings.combined_profile_bubble_btn_text"
            ></b-form-input>
        </b-form-group>

              </b-form-group>
        </b-tab> 
        <b-tab title="Advanced Settings">
              <b-form-group
                label="Deck URL"
                label-for="slug"
              >
              <b-input-group prepend="https://" :append="hosting_domain">
                <b-form-input id="slug" v-model="settings.slug" :required="true" @change="updateSetting" trim></b-form-input>
              </b-input-group>
              </b-form-group>
<!--
              <b-form-group
                label="Display Sender Profile by Default - Can be overridden on a per deck basis."
                label-for="default_show_user_profile"
                class="pt-3"
              >
                <b-form-checkbox id="default_show_user_profile" v-model="settings.default_show_user_profile" name="check-button" @change="updateSetting" switch>
                  {{ settings.default_show_user_profile ? 'Show': 'Hide'}} Sender Profile Button by Default
                </b-form-checkbox>
              </b-form-group>

              <b-form-group
                label="Display Company Profile (Desktop View) by Default - Can be overridden on a per deck basis."
                label-for="default_show_company_profile"
                class="pt-3"
              >
                <b-form-checkbox id="default_show_company_profile" v-model="settings.default_show_company_profile" name="check-button" @change="updateSetting" switch>
                  {{ settings.default_show_company_profile ? 'Show': 'Hide'}} Company Profile by Default
                </b-form-checkbox>
              </b-form-group>
-->
        </b-tab>
      </b-tabs>


      <b-button class="pull-right" @click="save()">Save Settings</b-button>

  </div>
</template>

<script>

import axios from 'axios';
import Noty from 'noty';

export default {
  mounted() {
    this.csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    this.loadCompanySettings();

  },
  props: [
      'hosting_domain'
  ],
  data() {
    return {
      csrf: null,
		  settings_loaded: false,
      unsaved: false,
      tabIndex: 0,
      settings:[],
      font_select:[],
      size_select:[
          { value: '1', text: 'Small' },
          { value: '2', text: 'Medium' },
          { value: '3', text: 'Large' },
          { value: '4', text: 'X-Large' }
        ],
      websiteProtocol:'',
      websiteDomain:'',
      bookingProtocol:'',
      bookingDomain:'',
      facebookPrefix:'https://www.facebook.com/',
      facebookURL:'',
      twitterPrefix:'https://twitter.com/',
      linkedinURL:'',
      linkedinPrefix:'https://linkedin.com/',
      twitterURL:'',
      instagramPrefix:'https://www.instagram.com/',
      instagramURL:'',
    };
  },
  methods: {
        save: function(currentTabIndex=null,newTabIndex=null){
            var vm = this;
            if(vm.settings_loaded){

              axios.post('/company/update',vm.settings).then(response => {

                if(response.data.status == 'success'){
                    vm.unsaved = false;
                  if(newTabIndex !== null){
                      vm.tabIndex = newTabIndex;
                  }
                  vm.showNoty('success','Settings Saved',3000);
                }else{
                  vm.showNoty('error',response.data.message,3000);
                }               

              }).catch(function(error){ vm.handleError(error) });


            }else{
              vm.showNoty('error','Still loading, please try again',3000);
            }

        },
        checksave(newTabIndex,currentTabIndex, event){
          var vm = this;

          if(vm.unsaved){
              event.preventDefault();
              var n = new Noty({
                    text: 'You have unsaved changes. Would you like to save them?',
                    theme: 'bootstrap-v4',
                    type: 'alert',
                    layout: 'topCenter',
                    timeout: false,  
                    buttons: [
                    Noty.button('Don\'t Save', 'btn btn-secondary', function () {
                        vm.settings_loaded = false;
                        vm.loadCompanySettings(newTabIndex);
                        n.close();
                    }),
                    Noty.button('Save', 'btn btn-primary pull-right', function () {
                        vm.save(currentTabIndex,newTabIndex);
                        n.close();
                    })
                    ],

              }).show();
          }

        },
        loadCompanySettings(newTabIndex=null){
            
            var vm = this;
            vm.settings_loaded = false;

            axios.get('/company/get').then(response => {

            if(response.data.status == 'success'){

              vm.settings = response.data['company'];
              if(vm.settings.website == null){vm.settings.website = '';}
              if(vm.settings.website.indexOf("http://") !== -1){
                vm.websiteProtocol = 'http://';
              }else{
                vm.websiteProtocol = 'https://';
              }

              vm.websiteDomain = vm.settings.website.replace(/(^\w+:|^)\/\//, '');

              if(vm.settings.booking_url == null){vm.settings.booking_url = '';}
              if(vm.settings.booking_url.indexOf("http://") !== -1){
                vm.bookingProtocol = 'http://';
              }else{
                vm.bookingProtocol = 'https://';
              }

              vm.bookingDomain = vm.settings.booking_url.replace(/(^\w+:|^)\/\//, '');
              

              if(vm.settings.twitter == null){vm.settings.twitter = '';}
              vm.twitterURL = vm.settings.twitter.replace(vm.twitterPrefix, "");;
              if(vm.settings.facebook == null){vm.settings.facebook = '';}
              vm.facebookURL = vm.settings.facebook.replace(vm.facebookPrefix, "");;
              if(vm.settings.linkedin == null){vm.settings.linkedin = '';}
              vm.linkedinURL = vm.settings.linkedin.replace(vm.linkedinPrefix, "");;
              if(vm.settings.instagram == null){vm.settings.instagram = '';}
              vm.instagramURL = vm.settings.instagram.replace(vm.instagramPrefix, "");;




              vm.font_select = response.data['font_select'];
              vm.settings_loaded = true;
              vm.unsaved = false;

              if(newTabIndex !== null){
                vm.tabIndex = newTabIndex;
              }

            }else{
              vm.handleError(error)
            }

          }).catch(function(error){ vm.handleError(error) });

        },
        updateSetting: function(setting=null,value=null){
          var vm = this;
          vm.unsaved = true;
          if(setting){
            vm.settings[setting]=value;
          }
          vm.$nextTick(function () {
            vm.$refs.previewform.submit();
          });

        },
        updateCompanyLogo: function(value) {
          this.settings.logo = value;
        },
        updateBackground: function(value) {
          this.settings.background = value;
        },
        updateProfileBackground: function(value) {
          this.settings.profile_background = value;
        },
        handleError: function(error){

            console.log('meeps1',error);

            if(error.response.status == '419'){
              console.log('meeps2');
              this.showLoggedOutNoty();
            }else{
              console.log('meeps3');
              this.showGeneralErrorNoty();
            }

        },
        showNoty: function(type='warning',message='',timeout=false){
          new Noty({
                    text: message,
                    type: type,
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: timeout
                }).show();
        },
        showGeneralErrorNoty: function(){
          new Noty({
                    text: 'There has been an error. Please <a href="javascript:window.location.reload(true)">refresh this page</a> and try again.',
                    type: 'error',
                    theme: 'bootstrap-v4',
                    layout: 'topCenter',
                    timeout: false
                }).show();
        },
        showLoggedOutNoty: function(){
          new Noty({
              text: 'You have been logged out due to inactivity. Please <a href="javascript:window.location.reload(true)">refresh this page</a> to login.',
              type: 'error',
              theme: 'bootstrap-v4',
              layout: 'topCenter',
              timeout: false
          }).show();
        },  
   },
    watch: {
        websiteProtocol(){
          if(this.websiteDomain==''){this.settings.website = null;}else{
          	this.settings.website = this.websiteProtocol+this.websiteDomain;
          }
        },
        websiteDomain(){
          if(this.websiteDomain==''){this.settings.website = null;}else{
          	this.settings.website = this.websiteProtocol+this.websiteDomain;
          }
        },
        bookingProtocol(){
          if(this.bookingDomain==''){this.settings.booking_url = null;}else{
            this.settings.booking_url = this.bookingProtocol+this.bookingDomain;
          }
        },
        bookingDomain(){
          if(this.bookingDomain==''){this.settings.booking_url = null;}else{
            this.settings.booking_url = this.bookingProtocol+this.bookingDomain;
          }
        },
        twitterURL(){
          this.settings.twitter = this.twitterPrefix+this.twitterURL;
        },
        linkedinURL(){
          this.settings.linkedin = this.linkedinPrefix+this.linkedinURL;
        },
        facebookURL(){
          this.settings.facebook = this.facebookPrefix+this.facebookURL;
        },
        instagramURL(){
          this.settings.instagram = this.instagramPrefix+this.instagramURL;
        },

    },
    computed: {

    }
  }
</script>